// extracted by mini-css-extract-plugin
export default {"thirdPartyBtnWrapper":"y2-z"};